export const RED_ZONE_INCIDENT_TYPES = {
  SUSPICIOUS_VEHICLE: 'SUSPICIOUS_VEHICLE',
  SUSPICIOUS_PERSON: 'SUSPICIOUS_PERSON',
  SUSPICIOUS_ACTIVITY: 'SUSPICIOUS_ACTIVITY',
  SURVEILLANCE_RECON: 'SURVEILLANCE_RECON',
  APPROACH_BEHAVIOR: 'APPROACH_BEHAVIOR',
  LOITERING: 'LOITERING',
  PHOTOGRAPHY_VIDEO: 'PHOTOGRAPHY_VIDEO',
  FOLLOWING: 'FOLLOWING',
  ACCESS_ATTEMPT: 'ACCESS_ATTEMPT',
  OTHER: 'OTHER',
} as const;

export type RedZoneIncidentType =
  (typeof RED_ZONE_INCIDENT_TYPES)[keyof typeof RED_ZONE_INCIDENT_TYPES];

export const RED_ZONE_INCIDENT_TYPE_OPTIONS: {
  value: RedZoneIncidentType;
  label: string;
}[] = [
  {
    value: RED_ZONE_INCIDENT_TYPES.SUSPICIOUS_VEHICLE,
    label: 'Suspicious Vehicle',
  },
  {
    value: RED_ZONE_INCIDENT_TYPES.SUSPICIOUS_PERSON,
    label: 'Suspicious Person',
  },
  {
    value: RED_ZONE_INCIDENT_TYPES.SUSPICIOUS_ACTIVITY,
    label: 'Suspicious Activity',
  },
  {
    value: RED_ZONE_INCIDENT_TYPES.SURVEILLANCE_RECON,
    label: 'Surveillance / Recon',
  },
  {
    value: RED_ZONE_INCIDENT_TYPES.APPROACH_BEHAVIOR,
    label: 'Approach Behavior',
  },
  {
    value: RED_ZONE_INCIDENT_TYPES.LOITERING,
    label: 'Loitering',
  },
  {
    value: RED_ZONE_INCIDENT_TYPES.PHOTOGRAPHY_VIDEO,
    label: 'Photography / Video',
  },
  {
    value: RED_ZONE_INCIDENT_TYPES.FOLLOWING,
    label: 'Following',
  },
  {
    value: RED_ZONE_INCIDENT_TYPES.ACCESS_ATTEMPT,
    label: 'Access Attempt',
  },
  {
    value: RED_ZONE_INCIDENT_TYPES.OTHER,
    label: 'Other',
  },
];

export const getRedZoneIncidentTypeLabel = (
  incidentType: RedZoneIncidentType
) => {
  return (
    RED_ZONE_INCIDENT_TYPE_OPTIONS.find(
      (option) => option.value === incidentType
    )?.label ?? incidentType
  );
};
